import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-slide',
  imports: [CommonModule],
  templateUrl: './slide.component.html',
  styleUrl: './slide.component.css'
})
export class SlideComponent {
  @ViewChild('slider') slider!: ElementRef<HTMLDivElement>;
  images: string[] = [
    "https://images.unsplash.com/photo-1641569618527-68e26db76db0?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1642711374706-31b9f801f445?q=80&w=1476&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1592782985575-a96c6e647155?q=80&w=1528&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://plus.unsplash.com/premium_photo-1718204438280-484021f08ca1?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  ];
  index = 0;
  intervalId: any;

  ngAfterViewInit() {
    this.startAutoSlide();
  }

  showSlide(i: number) {
    if (!this.slider) return;
    if (i >= this.images.length) this.index = 0;
    if (i < 0) this.index = this.images.length - 1;
    this.slider.nativeElement.style.transform = `translateX(-${this.index * 100}%)`;
  }

  nextSlide() {
    this.index++;
    this.showSlide(this.index);
  }

  prevSlide() {
    this.index--;
    this.showSlide(this.index);
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.index++;
      this.showSlide(this.index);
    }, 5000);
  }

  ngOnDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
